import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { resetPassword } from 'modules/account/features/forgotPassword/api';

export const useMutationResetPassword = (navigateToLogin: () => void) => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();
  const { mutate, status } = useMutation(resetPassword, {
    onSuccess: () => {
      successToast('Success');
      navigateToLogin();
    },
    onError: (error: any) => {
      errorToast(t(error?.response?.data?.errorDescription));
    },
  });

  return { mutate, status };
};
